<template>
  <div class="purchaseOverview">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeContract="changeContract"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showFooter="1 == 1"
        :footerMethod="footerMethod"
        rowKey="contractNo"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title ? ($utils.hasChina(item.title) ? item.title : $t(item.title)) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field == 'isGenerateSales'">
              {{ scope.row[item.field] ? '是' : '否' }}
            </span>
            <!-- <span v-else-if="item.field == 'shipComplete'"> 否 </span> -->
            <span v-else-if="item.field == 'contractValidStart'">
              <template v-if="scope.row['contractValidStart'] && scope.row['contractValidEnd']">
                {{ scope.row['contractValidStart'] }}至{{ scope.row['contractValidEnd'] }}
              </template>
            </span>
            <template
              v-else-if="
                ['productQuantity', 'deliverableQuantity', 'businessContractUnitPrice'].includes(
                  item.field
                )
              "
              >{{ replaceLastZeroStr(scope.row[item.field]) }}</template
            >
            <template v-else-if="['contractTotalAmount'].includes(item.field)">{{
              replaceZeroStr(scope.row[item.field])
            }}</template>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <choiceType ref="choiceType" />
    <originals-received-dialog
      ref="OriginalsReceivedDialog"
      :vFlag="'purchase'"
      @confirm="resetBtnClick"
    />
    <SiruiUpload
      ref="siruiUpload"
      isShowDownTemplateBtn
      @getData="getData"
      :action="action"
      :data="importData"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import BASE_API from '@/api/dataBase.js';
  import COM_API from '@/api/masterData/company.js';
  import choiceType from '../../components/choiceType';
  import SiruiUpload from '@/components/SiruiUpload';
  // import { filterEmpty, toLine, getUserCompanyList } from '@/common/js/util';
  import { filterEmpty, toLine } from '@/common/js/util';
  // import InputNumber from '@/components/form-item/input-number';
  import OriginalsReceivedDialog from '../../components/originalsReceivedDialog.vue';
  import ORDER_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import { yesNoList } from '@/constants';
  export default {
    name: 'purchaseOverview',
    mixins: [tableMixins],
    components: {
      choiceType,
      SiruiUpload,
      // InputNumber,
      OriginalsReceivedDialog,
    },
    data() {
      return {
        // footerTotalCols: {
        //   amount: ['contractTotalAmount'],
        //   quantity: ['productQuantity'],
        // }, //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        query: {
          contractDetailCategory: null,
          externalContractNo: null,
          intentionNo: null,
          contractNo: null,
          tradeType: null,
          contractCreateStartDate: null,
          contractCreateEndDate: null,
          storage: null,
          amountStart: undefined,
          amountEnd: undefined,
          // customer: null,
          product: null,
          settleBatchNumber: null,
          priceStart: undefined,
          priceEnd: undefined,
          quantityStart: undefined,
          quantityEnd: undefined,
          contractBusinessCompanyNo: null,
          contractBusinessDepartment: null,
          contractSalesman: null,
          contractOperaterNo: null,
          supplier: null,
          contractStatus: null,
          lastestPayMoneyDay: null,
          lastestReceiveProductDay: null,
          supplychain: null,
          businessType: null,
          isFixedPrice: null,
          isPrepay: null,
          businessOrder: null, //业务订单
          receiptCondition: null, //付款条件
          isNotProxy: null, //贸易合同-非代理,1-是,0-否',
          distributionBatchNo: null,
          originalsReceivedBusiness: null,
          originalsReceivedRm: null,

          //新增字段
          pricingRule: null,
          shipComplete: null,
          contractValidStart: null,
          contractValidEnd: null,
          projectName: null,
          isPersonalPartner: null,
        },
        isIntention: '',
        //意向单号禁用状态
        intDisabled: false,
        //合同号禁用状态
        contDisabled: false,
        departmentList: [],
        //排序条件
        sortParams: '',
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'projectInitiationNo',
            title: '项目编号',
            visible: true,
          },
          {
            field: 'projectName',
            title: '项目简称',
            visible: true,
          },
          {
            field: 'contractNo',
            title: '合同编号',
            visible: true,
          },
          {
            field: 'oaUrl',
            title: '审批详情',
          },
          // {
          //   field: 'shipComplete',
          //   title: '是否完全发货',
          //   visible: true,
          // },
          {
            field: 'productQuantity',
            title: '采购数量',
            visible: true,
          },
          {
            field: 'deliverableQuantity',
            title: '剩余可发货数量',
            visible: true,
          },
          {
            field: 'receiptMethodName',
            title: '付款方式',
            visible: true,
          },
          {
            field: 'externalContractNo',
            title: '外部合同号',
            visible: true,
          },
          // {
          //   field: 'tradeTypeName',
          //   title: '贸易类型',
          //   visible: true,
          // },
          {
            field: 'supplierName',
            title: '供应商名称',
            visible: true,
          },
          {
            field: 'businessTypeName',
            title: '业务性质',
            visible: true,
          },
          {
            field: 'contractDetailCategoryName',
            title: '制单类型',
            visible: true,
          },
          // {
          //   field: 'contractNo',
          //   title: '采购号(合同/意向单)',
          //   width: '120',
          //   visible: true,
          // },
          {
            field: 'originalsReceivedBusiness',
            title: '正本收集状态',
            width: '100',
            dictType: 'originalsReceivedBusiness',
            visible: true,
          },
          {
            field: 'originalsReceivedRm',
            title: '正本归档状态',
            width: '100',
            dictType: 'originalsReceivedRm',
            visible: true,
          },
          {
            field: 'contractBusinessCompanyName',
            title: '公司',
            visible: true,
          },
          {
            field: 'contractTotalAmount',
            title: '合同总金额',
            // format: 'formatAmountRound',
            visible: true,
            sortable: true,
          },
          {
            field: 'productDesc',
            title: '商品描述',
            visible: true,
            sortable: true,
          },
          // {
          //   //直拨流向
          //   field: 'deliveryPlaceName',
          //   title: '直拨流向',
          //   visible: true,
          // },
          // {
          //   //合同数量
          //   field: 'productQuantity',
          //   title: '合同数量',
          //   format: 'formatQuality',
          //   visible: true,
          //   sortable: true,
          // },
          //合同单价
          {
            field: 'businessContractUnitPrice',
            title: '合同单价',
            visible: true,
            // format: 'formatPrice',
            sortable: true,
          },
          {
            field: 'contractStatusName',
            title: '单据状态',
            visible: true,
          },
          {
            field: 'isFixedPriceName',
            title: '不定价',
            visible: true,
          },
          {
            field: 'isPrepayName',
            title: '预付',
            visible: true,
          },
          {
            field: 'contractBusinessDepartmentName',
            title: '业务部门',
            visible: true,
          },
          {
            field: 'contractSalesmanName',
            title: '业务员',
            visible: true,
          },
          //操作人
          {
            field: 'contractOperaterName',
            title: '操作人',
            visible: true,
          },
          // {
          //   field: 'receiptConditionName',
          //   title: '付款条件',
          //   visible: true,
          // },
          {
            field: 'lastestPayMoneyDay',
            title: '最晚付款日',
            visible: true,
          },
          {
            field: 'lastestReceiveProductDay',
            title: '最晚收货日',
            visible: true,
          },
          {
            field: 'replyInvoiceDate',
            title: '回票日期',
            visible: true,
          },
          {
            field: 'contractCurrencyName',
            title: '货币',
            visible: true,
          },
          {
            field: 'liquidatedDamagesType',
            title: '合同违约金类型',
            visible: true,
          },
          {
            field: 'liquidatedFixedValue',
            title: '违约金固定值',
            visible: true,
          },
          {
            field: 'liquidatedInterestRate',
            title: '违约金日利率',
            visible: true,
          },
          {
            field: 'overShippedPercentage',
            title: '溢装比例',
            visible: true,
          },
          {
            field: 'shortShippedPercentage',
            title: '短装比例',
            visible: true,
          },
          {
            field: 'signDate',
            title: '合同签署日期',
            visible: true,
          },
          {
            field: 'contractValidStart', // TODO
            title: '合同期限',
            visible: true,
            width: 200,
          },
          {
            field: 'contractName',
            title: '合同名称',
            visible: true,
          },
          {
            field: 'pricingRuleName',
            title: '定价模式',
            visible: true,
          },
          {
            field: 'isGenerateSales',
            title: '是否关联销售合同/协议',
            visible: true,
          },
          {
            field: 'generateNo',
            title: '关联销售合同号',
            visible: true,
          },
          {
            field: 'contractCreateDate',
            title: '制单日期',
            visible: true,
            sortable: true,
          },
        ],
      };
    },
    computed: {
      action() {
        return API.IMPORT_ORDER_API_CK;
      },
      searchColumns() {
        return [
          {
            prop: 'contractDetailCategory',
            name: '制单类型',
            type: 'ajaxSelect',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'purchase_contract_detail_category' },
            changeMethod: 'changeContract',
          },
          // {
          //   prop: 'externalContractNo',
          //   name: '外部合同号',
          //   type: 'input',
          //   maxlength: 50,
          // },
          // {
          //   prop: 'intentionNo',
          //   name: this.$t('salePurchase.search.intentionNo'),
          //   type: 'input',
          //   maxlength: 50,
          //   disabled: this.intDisabled,
          //   placeholder: this.$t('salePurchase.search.intentionNoPlaceholder'),
          // },
          {
            prop: 'contractNo',
            name: '合同编号',
            type: 'input',
            maxlength: 50,
            disabled: this.contDisabled,
          },
          // fixme合同期限 开始结束，确认字段是否修改
          // {
          //   prop: 'contractValidStart',
          //   name: '合同期限从',
          //   type: 'startDaterangePicker',
          //   placeholder: '开始日期',
          // },
          // {
          //   prop: 'contractValidEnd',
          //   name: '合同期限至',
          //   type: 'endDaterangePicker',
          //   placeholder: '结束日期',
          // },
          {
            prop: 'contractName',
            name: '合同名称',
            type: 'input',
            placeholder: '请输合同名称',
          },
          {
            prop: 'projectName',
            name: '项目简称',
            searchType: 'projectInitiation',
            type: 'searchTableSpec',
            isMultiple: true,
            currentValue: this.query?.projectName ? this.query?.projectName : null,
            // checkRowKeys: [this.query.projectInitiationNo ? this.query.projectInitiationNo : null],
            extraData: {
              projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
              // applyCompanyNo: this.query.companyCode,
              // applyDepartmentNo: this.query.contractBusinessDepartment,
              // platformtCompany: this.query.companyCode,
              // recyclingtCompany: this.query.companyCode,
              // applyDepartmentName: this.query.contractBusinessDepartmentName,

              // applyCompanyName: this.query.companyName
              //   ? this.query.companyName
              //   : this.userInfo.userInfo.companyName,
              // platformtCompanyName: this.query.companyName
              //   ? this.query.companyName
              //   : this.userInfo.userInfo.companyName,
              // recyclingtCompanyName: this.query.companyName
              //   ? this.query.companyName
              //   : this.userInfo.userInfo.companyName,
            },
            changeMethod: 'changeContract',
          },
          {
            type: 'searchTableSpec',
            name: '供应商名称',
            prop: 'supplier',
            searchType: 'supplier',
            extraData: {
              // partnerTypes: 'HZHB03,HZHB02',
              departmentCode: this.query.contractBusinessDepartment, //部门
              companyCode: this.query.contractBusinessCompanyNo, //公司
            },
            isNeedMultipleValue: true,
          },
          // {
          //   type: 'inputRange',
          //   prop: ['amountStart', 'amountEnd'],
          //   precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
          //   max: 99999999999999.99,
          //   name: '合同总金额',
          // },

          // {
          //   type: 'inputRange',
          //   prop: ['quantityStart', 'quantityEnd'],
          //   precision: this.$globalVar.aPoint, //整数
          //   max: 99999999999999.99,
          //   name: this.$t('salePurchase.search.purchaseQuantity'),
          // },
          {
            prop: 'contractBusinessDepartment',
            name: '业务部门',
            type: 'treeSelect',
            apiUrl: COM_API.LIST_COMPANY_API,
            trigger: 'click',
            // TODO 等待修复
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
              companyNoList: this.query.contractBusinessCompanyNo
                ? [this.query.contractBusinessCompanyNo]
                : [],
            },
            multiple: true,
            clearable: false,
          },
          {
            prop: 'contractStatus',
            name: '单据状态',
            type: 'ajaxSelect',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'contract_status' },
          },
          {
            prop: 'isPersonalPartner',
            name: '是否个人合作伙伴',
            type: 'select',
            placeholder: '请选择是否个人合作伙伴',
            options: yesNoList,
          },
          //不定价
          {
            prop: 'isFixedPrice',
            name: '不定价',
            type: 'select',
            options: [
              {
                label: '是',
                value: '1',
              },
              {
                label: '否',
                value: '0',
              },
            ],
          },
          // {
          //   prop: 'contractCreateStartDate',
          //   name: this.$t('salePurchase.search.contractCreateStartDate'),
          //   type: 'startDaterangePicker',
          // },
          // {
          //   prop: 'contractCreateEndDate',
          //   name: this.$t('salePurchase.search.contractCreateEndDate'),
          //   type: 'endDaterangePicker',
          // },
          // {
          //   prop: 'storage',
          //   type: 'searchTableSpec',
          //   name: this.$t('salePurchase.search.warehouse'),
          //   searchType: 'warehouse',
          //   isNeedMultipleValue: true,
          // },
          // {
          //   type: 'inputRange',
          //   prop: ['amountStart', 'amountEnd'],
          //   precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
          //   max: 99999999999999.99,
          //   name: '合同总金额',
          // },
          // {
          //   type: 'select', // 公司：操作人账户下公司
          //   name: this.$t('contractAgency.company'),
          //   prop: 'contractBusinessCompanyNo',
          //   options: getUserCompanyList(),
          //   // changeMethod: () => {
          //   //   this.query.contractBusinessDepartment = "";
          //   // }
          // },
          // {
          //   type: 'inputRange',
          //   prop: ['quantityStart', 'quantityEnd'],
          //   precision: this.$globalVar.aPoint, //整数
          //   max: 99999999999999.99,
          //   name: this.$t('salePurchase.search.purchaseQuantity'),
          // },

          {
            prop: 'product',
            type: 'searchTableSpec',
            name: '商品描述',
            searchType: 'product',
            isNeedMultipleValue: true,
            isMultiple: true,
            ref: 'productRef',
            extraData: {
              detailProductStatus: 'ZT03',
              contractCategory: 'purchase',
              adminFlag: 2,
              // selectCompanyCode: baseFormData.companyCode,
            },
            changeMethod: 'changeContract',
          },

          // {
          //   type: 'inputRange',
          //   prop: ['priceStart', 'priceEnd'],
          //   precision: this.$globalVar.aPoint, //精度，就是保留几位小数,默认两位
          //   max: 99999999999999.99,
          //   name: this.$t('salePurchase.search.businessContractUnitPrice'),
          // },

          // {
          //   prop: 'contractSalesman',
          //   type: 'searchTableSpec',
          //   name: '业务员',
          //   searchType: 'personnel',
          //   isNeedMultipleValue: true,
          //   changeMethod: 'changeContract',
          // },
          // {
          //   prop: 'contractOperaterNo',
          //   type: 'searchTableSpec',
          //   name: '操作人',
          //   searchType: 'personnel',
          //   isNeedMultipleValue: true,
          //   changeMethod: 'changeContract',
          // },

          // {
          //   prop: 'lastestPayMoneyDay',
          //   name: this.$t('salePurchase.search.lastestPayMoneyDay'),
          //   type: 'date',
          // },
          // {
          //   prop: 'lastestReceiveProductDay',
          //   name: this.$t('salePurchase.search.lastestReceiveProductDay'),
          //   type: 'date',
          // },

          // {
          //   prop: 'businessType',
          //   name: this.$t('salePurchase.search.businessType'),
          //   type: 'ajaxSelect',
          //   apiUrl: BASE_API.DIC_CREDIT_API,
          //   apiData: { dictType: 'purchase_business_type' },
          //   placeholder: this.$t('salePurchase.search.businessTypePlaceholder'),
          // },
          // //正本归档状态
          // {
          //   prop: 'originalsReceivedRm',
          //   name: '正本归档状态',
          //   type: 'dict',
          //   dictType: 'originalsReceivedRm',
          //   placeholder: '请输入正本归档状态',
          // },
          // {
          //   prop: 'isPrepay',
          //   name: this.$t('salePurchase.search.isPrepay'),
          //   type: 'select',
          //   placeholder: this.$t('salePurchase.search.isPrepayPlaceholder'),
          //   options: [
          //     {
          //       label: '是',
          //       value: 1,
          //     },
          //     {
          //       label: '否',
          //       value: 0,
          //     },
          //   ],
          // },

          // {
          //   prop: 'originalsReceivedBusiness',
          //   name: '正本收集状态',
          //   type: 'dict',
          //   dictType: 'originalsReceivedBusiness',
          //   placeholder: '请输入正本收集状态',
          // },
          // //定价规则
          // {
          //   prop: 'pricingRule',
          //   name: '定价模式',
          //   type: 'ajaxSelect',
          //   clearable: true,
          //   apiUrl: BASE_API.DIC_CREDIT_API,
          //   apiData: { dictType: 'pricing_rule' },
          //   placeholder: this.$t('salePurchase.search.pricingRulePlaceholder'),
          //   disabled: this.pricingRuleDisabled,
          //   changeMethod: 'changeCurrency',
          // },
          {
            prop: 'isGenerateSales',
            name: '是否关联销售合同/协议',
            type: 'select',
            clearable: true,
            options: [
              {
                label: '是',
                value: true,
              },
              {
                label: '否',
                value: false,
              },
            ],
          },
          {
            prop: 'generateNo',
            name: '关联销售合同号',
            clearable: true,
            type: 'input',
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
      }),
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.userInfo.access_token,
          lang: this.lang,
          oaId: this.userInfo.userInfo.oaId,
        };
      },
    },
    mounted() {
      if (this.$route.query.contractDetailCategory) {
        this.query.contractDetailCategory = this.$route.query.contractDetailCategory;
        this.getData();
      }
      // this.query.customer = this.userInfo.userInfo.companyCode;
      this.$nextTick(() => {
        this.getButtonList();
        this.getDepartment();
        this.getData();
      });
    },
    watch: {
      $route() {
        this.getData(); // 监听路由变动调用接口
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        // amount: ['contractTotalAmount'],
        //   quantity: ['productQuantity'],
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['contractTotalAmount'].includes(column.property)) {
              return this.replaceZeroStr(
                data.reduce((cur, next) => cur + +next.contractTotalAmount, 0).toFixed(2)
              );
            } else if (['productQuantity'].includes(column.property)) {
              return this.replaceLastZeroStr(
                data.reduce((cur, next) => cur + +next.productQuantity, 0).toFixed(2)
              );
            }
            return null;
          }),
        ];
      },
      //初始化数据
      getData() {
        // 删除选中的元素
        // this.multipleSelection = []; //初始化选中数据
        // this.$refs.siruiTable.clearCheckboxReserve();
        //如果没有查询条件，提示信息
        let count = Object.keys(this.query).length;
        for (var key in this.$refs.siruiSearch.query) {
          if (
            this.$refs.siruiSearch.query[key] == null ||
            this.$refs.siruiSearch.query[key] == undefined ||
            this.$refs.siruiSearch.query[key] == ''
          ) {
            count = count - 1;
          }
        }
        // if (count == 0) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("salePurchase.nosearchError"),
        //     type: "error"
        //   });
        //   return;
        // }
        //如果不选制单类型  但是同时输入了意向单和合同号 提示报错
        if (
          this.$refs.siruiSearch.query.intentionNo &&
          this.$refs.siruiSearch.query.contractNo &&
          this.$refs.siruiSearch.query.contractDetailCategory == null
        ) {
          this.$message({
            showClose: true,
            message: this.$t('salePurchase.noTypeSearchError'),
            type: 'error',
          });
          return;
        }
        let params = this.getQueryData();
        //默认 制单日期倒叙
        params.orderByDesc = this.sortParams;
        params.dataGroup = this.$globalVar.dataGroup;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.businessGroup = this.userInfo.userInfo.businessGroup;
        this.load = true;
        this.$axios
          .post(API.GET_LIST_API, {
            ...params,
            contractBusinessDepartment: params.contractBusinessDepartment
              ? params.contractBusinessDepartment
              : null, //this.userInfo.userInfo.departmentCode,
          })
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data.list;
              if (this.$refs.siruiTable) {
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //处理查询数据
      getQueryData() {
        const query = Object.assign({}, this.$refs.siruiSearch.query);

        query.contractCategory = 'purchase';
        query.groupByContractDetailNoFlag = '1'; //区分当前接口是否为采销合同调用
        //意向单和合同号是同一个字段
        //如果意向单号有值  则将意向单号传给合同号
        if (query.contractDetailCategory == null) {
          query.contractNo = query.intentionNo ? query.intentionNo : query.contractNo;
        } else {
          if (query.contractDetailCategory == 'HT04') {
            query.contractNo = query.intentionNo;
          }
        }
        //客户
        // let item = XEUtils.find(
        //   JSON.parse(this.userInfo.userInfo.companyList),
        //   item => item["personCompanyCode"] === query.customer
        // );

        //仓库
        query.storageNo = this.handleData(query.storage, 'storageCode');
        //商品描述
        // query.productNo = this.handleData(query.product, 'productDetailCode');
        //业务员ContractSalesmanNo
        query.contractSalesmanNo = this.handleData(query.contractSalesman, 'id');
        //操作人
        query.contractOperaterNo = this.handleData(query.contractOperaterNo, 'id');
        //业务公司赋初值
        // query.contractBusinessCompanyNo = this.userInfo.userInfo.companyCode;
        // query.contractBusinessCompanyName = this.userInfo.userInfo.companyName;
        //供应链主体
        query.supplychainNo = this.handleData(query.supplychain, 'supplierCode');
        //供应商
        query.supplierNo = this.handleData(query.supplier, 'partnerCode');
        //业务订单
        query.businessOrder = query.businessOrder ? query.businessOrder[0].orderNo : null;
        delete query.contractSalesman;
        return filterEmpty({ ...query });
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            //合并的数据
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item[key]);
            }
          } else if (key == 'supplierCode') {
            //合并的数据
            if (item.allSupplierCode && item['allSupplierCode'] != undefined) {
              list.push(item.allSupplierCode);
            } else {
              list.push(item[key]);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item[key]);
            }
          } else {
            if (item[key] && item[key] != undefined) {
              list.push(item[key]);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      //搜索区域控制切换事件
      changeContract(obj) {
        console.log(obj, '???');
        if (obj.prop == 'projectName') {
          console.log(obj);
          const rowData = (obj.val && obj.val[0]) || {};
          this.query.projectName = rowData.projectAbbreviation;
        }
        if (obj.prop == 'product') {
          this.query.productNo = obj.val[0].parentProductNo;
        }
        let arr = ['HT01', 'HT02', 'HT03'];
        //如果是意向单,则意向单号可填，合同号禁用
        if (obj.val == 'HT04') {
          this.contDisabled = true;
          this.intDisabled = false;
          this.query.contractNo = null;
        } else if (arr.includes(obj.val)) {
          //如果是合同或协议,则合同号可填，意向单号禁用
          this.intDisabled = true;
          this.contDisabled = false;
          this.query.intentionNo = null;
        } else {
          this.intDisabled = false;
          this.contDisabled = false;
          this.query.intentionNo = null;
          // this.query.contractNo = null;
        }
      },
      //排序
      sortChangeEvent({ property, order }) {
        // this.sortParams = "tos.contract_create_date desc";
        if (order) {
          if (['contractTotalAmount', 'contractCreateDate'].indexOf(property) > -1) {
            this.sortParams = `tos.${toLine(property)} ${order}`;
          } else {
            this.sortParams = `tosd.${toLine(property)} ${order}`;
          }
        } else {
          this.sortParams = '';
        }
        this.getData();
      },
      //获取部门
      async getDepartment() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.userInfo.userInfo.companyCode,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        this.departmentList = selectStatus.data.data.personDepartmentInfo;
        this.departmentList.forEach((item) => {
          item.value = item.personDepartmentCode;
          item.label = item.personDepartmentName;
        });
      },
      // 列表双击
      dblclickEvent(value) {
        console.log(value, '双击行');

        //已生效的 只能修改关联明细和点价已经结算批次
        const contractDetailCategory = value.row.contractDetailCategory;
        const contractNo = value.row.contractNo;
        console.log(contractDetailCategory, '==当前类型=??');
        // const contractStatus = value.row.contractStatus;
        const id = value.row.id;
        let path = {};
        //采购协议
        if (contractDetailCategory == 'CG02') {
          path = {
            path: '/salePurchase/purchaseAgreementEdit',
            name: 'purchaseAgreementEdit',
            meta: {
              keepAlive: true,
              title: '采购协议编辑',
            },
            query: {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              copy: '0',
              contractCategory: 'purchase',
            },
          };
        }
        // 采购合同
        if (contractDetailCategory == 'CG01') {
          path = {
            path: '/salePurchase/purchaseContractEdit',
            name: 'purchaseContractEdit',
            meta: {
              keepAlive: true,
              title: '采购合同编辑',
            },
            query: {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              isEdit: true,
              contractCategory: 'purchase',
            },
          };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },

      //复制合同
      copyContract() {
        console.log(this.multipleSelection, '行');
        if (this.multipleSelection.length != 1) {
          this.$message.warning('只能选择一行操作');
          return;
        }
        //已驳回状态不可复制
        if (this.multipleSelection[0].contractStatus != 'ZT03') {
          let type = this.query.contractDetailCategory;

          let tips =
            type === 'HT03'
              ? 'noCopyContractTips'
              : type === 'HT04'
              ? 'noCopyIntentionTips'
              : 'noCopyAgreementTips';

          if (type == 'CG01') {
            tips = '只能复制已生效的合同';
          } else if (type == 'CG02') {
            tips = '只能复制已生效的协议';
          }

          this.$message({
            showClose: true,
            message: this.$t(`salePurchase.${tips}`),
            type: 'error',
          });
          return;
        }
        //跳转到复制即新增页面
        // this.handleCopyPath(
        //   this.multipleSelection[0].contractDetailCategory,
        //   this.multipleSelection[0].contractNo
        // );
        let path = {};
        const rowData = this.multipleSelection[0];
        const contractDetailCategory = rowData.contractDetailCategory;
        const contractNo = rowData.contractNo;
        // 采购合同
        if (contractDetailCategory == 'CG01') {
          path = {
            path: '/salePurchase/purchaseContractCreation',
            name: 'purchaseContractCreation',
            meta: {
              keepAlive: true,
              title: '复制采购合同',
            },
            query: {
              type: contractDetailCategory,
              contractNo: contractNo,
              isCopy: 'true',
              isEdit: 'false',
            },
          };
        }
        // 采购协议
        if (contractDetailCategory == 'CG02') {
          path = {
            path: '/salePurchase/purchaseAgreementCreation',
            name: 'purchaseAgreementCreation',
            meta: {
              keepAlive: true,
              title: '拷贝采购协议',
            },
            query: {
              type: contractDetailCategory,
              contractNo: contractNo,
              isCopy: 'true',
              isEdit: 'false',
            },
          };
        }
        // // 销售协议
        // if (contractDetailCategory == 'CG03') {
        //   path = {
        //     path: '/salePurchase/saleAgreementCreation',
        //     name: 'saleAgreementCreation',
        //     meta: {
        //       keepAlive: false,
        //       title: '销售协议创建',
        //     },
        //     query: {
        //       type: this.radio,
        //       isEdit: false,
        //     },
        //   };
        // }
        console.log('打开文件');
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleCopyPath(contractDetailCategory, contractNo) {
        let pathName = '';
        let title = '';
        let url = '';
        //年度采购协议
        if (contractDetailCategory == 'HT01') {
          pathName = 'yearPurchase';
          title = '年度采购协议创建';
          url = '/salePurchase/yearPurchase';
        }
        //月度采购协议
        if (contractDetailCategory == 'HT02') {
          pathName = 'monthPurchase';
          title = '月度采购协议创建';
          url = '/salePurchase/monthPurchase';
        }
        //单次采购合同
        if (contractDetailCategory == 'HT03') {
          pathName = 'singlePurchaseContract';
          title = '单次采购合同创建';
          url = '/salePurchase/singlePurchaseContract';
        }
        //采购意向单
        if (contractDetailCategory == 'HT04') {
          pathName = 'purchaseIntent';
          title = '采购意向单修改创建';
          url = '/salePurchase/purchaseIntent';
        }
        let path = {
          path: url,
          name: pathName,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: {
            isEdit: false,
            copy: true,
            type: contractDetailCategory,
            contractNo: contractNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除合同
      delete() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('contractAgency.errorTips.deleteEmptyTip'),
            type: 'error',
          });
          return;
        }
        //可删除条件
        let isDelete = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].contractStatus != 'ZT06' &&
            this.multipleSelection[i].contractStatus != 'ZT05'
          ) {
            isDelete = false;
            break;
          }
        }
        if (!isDelete) {
          let type = this.query.contractDetailCategory;
          let tips =
            type === 'HT03'
              ? 'noDeleteContractTips'
              : type === 'HT04'
              ? 'noDeleteIntentionTips'
              : 'noDeleteAgreementTips';
          this.$message({
            showClose: true,
            message: this.$t(`salePurchase.${tips}`),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            let ids = [];
            let contractNos = [];
            this.multipleSelection.forEach((item) => {
              ids.push(item.id);
              contractNos.push(item.contractNo);
            });
            this.loading.startLoading();
            this.$axios
              .post(API.DELETE_ORDER_API, {
                ids: ids,
                contractNos: contractNos,
                oaId: this.userInfo.userInfo.oaId,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //申请删除合同
      deleteCommit() {
        if (this.multipleSelection?.length == 0) {
          this.$message({
            showClose: true,
            message: '请至少选择一条数据进行操作',
            type: 'error',
          });
          return;
        }
        if (this.multipleSelection?.length > 1) {
          this.$message({
            showClose: true,
            message: '只能删除一条已生效且未创建供应商发货指令的合同，或已生效的协议',
            type: 'error',
          });
          return;
        }
        this.$confirmAction('提交删除申请', '是否确认提交删除申请？')
          .then(() => {
            // let ids = [];
            let contractNos = [];
            this.multipleSelection.forEach((item) => {
              contractNos.push(item.contractNo);
            });
            contractNos = this.unique(contractNos);
            this.loading.startLoading();
            this.$axios
              .post(API.DELETE_CONTRACT_COMMIT, {
                contractNos: contractNos,
                oaId: this.userInfo.userInfo.oaId,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //批量提交合同
      submitContract() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择已保存采购合同/协议进行提交',
            type: 'error',
          });
          return;
        }
        const isGenerateSales = this.multipleSelection.some((item) => item.isGenerateSales);
        if (isGenerateSales) {
          this.$message.warning('该合同已有关联销售合同，请到详情页提交审批');
          return;
        }
        //只有已保存和已驳回的才可以提交
        let isSubmit = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].contractStatus != 'ZT06' &&
            this.multipleSelection[i].contractStatus != 'ZT05' &&
            this.multipleSelection[i].contractStatus != 'ZT061' &&
            this.multipleSelection[i].contractStatus != 'ZT051'
          ) {
            isSubmit = false;
            break;
          }
        }
        if (!isSubmit) {
          let type = this.query.contractDetailCategory;
          let tips =
            type === 'HT03'
              ? 'noSubmitContractTips'
              : type === 'HT04'
              ? 'noSubmitIntentionTips'
              : 'noSubmitAgreementTips';
          this.$message({
            showClose: true,
            message: this.$t(`salePurchase.${tips}`),
            type: 'error',
          });
          return;
        }
        // for (let i = 0; i < this.multipleSelection.length; i++) {
        //   if (
        //     this.multipleSelection[i].contractTotalAmount == 0 ||
        //     !this.multipleSelection[i].contractTotalAmount
        //   ) {
        //     this.$message({
        //       showClose: true,
        //       message: this.multipleSelection[i].contractNo + '合同总金额为0,无法提交',
        //       type: 'error',
        //     });
        //     return;
        //   }
        // }
        let contractNos = [];
        let requestIds = [];
        this.multipleSelection.forEach((item) => {
          contractNos.push(item.contractNo);
          if (item.requestId) {
            requestIds.push(item.requestId);
          }
        });
        // this.loading.startLoading();
        this.$confirmAction(this.$t('confirm.submit'), this.$t('confirm.removeSubmit'))
          .then(() => {
            this.batchSubmit({
              contractNos: contractNos,
              oaId: this.userInfo.userInfo.oaId,
              requestIds: requestIds,
              contractCategory: 'purchase',
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('salePurchase.message.gitUpSubmit'),
            });
            this.loading.endLoading();
          });
      },
      batchSubmit(value) {
        this.loading.startLoading();
        this.$axios.post(API.SUBMIT_ORDER_API, value).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            this.searchBtnClick();
          } else {
            // this.$alert(res.data.msg);
            // this.$repeatAlert("<div><img src='./static/img/error.png'/><div class='confirmTitle'>" +
            //   this.$t("alert.error") +
            //   "</div>" +
            //   "<div class='confirmContent'>" +
            //   res.data.msg +
            //   "</div></div>",
            //   "", {
            //     dangerouslyUseHTMLString: true,
            //     center: true,
            //     confirmButtonText: this.$t("alert.confirm"),
            //     callback: action => {
            //       this.getData();
            //     }
            //   });
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                value.cancelValidate = true;
                this.batchSubmit(value);
                this.searchBtnClick();
              },
              callback2: () => {
                this.searchBtnClick();
              },
            });
          }
        });
      },

      //搜索区域控制切换事件
      // changeContract(obj) {
      //   let arr = ['HT01', 'HT02', 'HT03'];
      //   //如果是意向单,则意向单号可填，合同号禁用
      //   if (obj.val == 'HT04') {
      //     this.contDisabled = true;
      //     this.intDisabled = false;
      //     this.query.contractNo = null;
      //   } else if (arr.includes(obj.val)) {
      //     //如果是合同或协议,则合同号可填，意向单号禁用
      //     this.intDisabled = true;
      //     this.contDisabled = false;
      //     this.query.intentionNo = null;
      //   } else {
      //     this.intDisabled = false;
      //     this.contDisabled = false;
      //     this.query.intentionNo = null;
      //     this.query.contractNo = null;
      //   }
      // },
      //排序
      // sortChangeEvent({ property, order }) {
      //   // this.sortParams = "tos.contract_create_date desc";
      //   if (order) {
      //     if (['contractTotalAmount', 'contractCreateDate'].indexOf(property) > -1) {
      //       this.sortParams = `tos.${toLine(property)} ${order}`;
      //     } else {
      //       this.sortParams = `tosd.${toLine(property)} ${order}`;
      //     }
      //   } else {
      //     this.sortParams = '';
      //   }
      //   this.getData();
      // },
      //获取部门
      // async getDepartment() {
      //   const params = {
      //     id: this.userInfo.userInfo.userCode,
      //     userCode: this.userInfo.userInfo.userCode,
      //     personName: this.userInfo.userInfo.userName,
      //     personCompanyCode: this.userInfo.userInfo.companyCode,
      //   };
      //   const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
      //   this.departmentList = selectStatus.data.data.personDepartmentInfo;
      //   this.departmentList.forEach((item) => {
      //     item.value = item.personDepartmentCode;
      //     item.label = item.personDepartmentName;
      //   });
      // },
      // // 列表双击
      // dblclickEvent(value) {
      //   //已生效的 只能修改关联明细和点价已经结算批次
      //   this.handlePath(
      //     'edit',
      //     value.row.contractDetailCategory,
      //     value.row.contractNo,
      //     value.row.id,
      //     value.row.contractStatus
      //   );
      // },
      // handlePath(type, contractDetailCategory, contractNo, id, contractStatus) {
      //   let pathName = '';
      //   let title = '';
      //   let url = '';
      //   //年度采购协议
      //   if (contractDetailCategory == 'HT01') {
      //     pathName = 'yearPurchaseEdit';
      //     title = '年度采购协议修改';
      //     url = '/salePurchase/yearPurchaseEdit';
      //   }
      //   //月度采购协议
      //   if (contractDetailCategory == 'HT02') {
      //     pathName = 'monthPurchaseEdit';
      //     title = '月度采购协议修改';
      //     url = '/salePurchase/monthPurchaseEdit';
      //   }
      //   //单次采购合同
      //   if (contractDetailCategory == 'HT03' || contractDetailCategory == 'HT10') {
      //     pathName = 'singlePurchaseContractEdit';
      //     title = '单次采购合同修改';
      //     url = '/salePurchase/singlePurchaseContractEdit';
      //   }
      //   //采购意向单
      //   if (contractDetailCategory == 'HT04') {
      //     pathName = 'purchaseIntentEdit';
      //     title = '采购意向单修改';
      //     url = '/salePurchase/purchaseIntentEdit';
      //   }

      //   //采购协议
      //   if (contractDetailCategory == 'CG02') {
      //     pathName = 'purchaseAgreement';
      //     title = '采购协议修改';
      //     url = '/salePurchase/purchaseAgreementEdit';
      //   }

      //   //采购合同
      //   if (contractDetailCategory == 'CG04') {
      //     pathName = 'purchaseContractEdit';
      //     title = '采购合同修改';
      //     url = '/salePurchase/purchaseContractEdit';
      //   }

      //   let path = {
      //     path: url,
      //     name: pathName,
      //     meta: {
      //       keepAlive: true,
      //       title: title,
      //     },
      //     query: {
      //       id: id,
      //       type: contractDetailCategory,
      //       contractNo: contractNo,
      //       isEdit: contractStatus === 'ZT03' ? true : false,
      //     },
      //   };
      //   this.$store.dispatch('tagsView/addTabView', path).then(() => {
      //     this.$nextTick(() => {
      //       this.$router.push(path);
      //     });
      //   });
      // },

      unique(array) {
        let temp = [];
        let index = [];
        let l = array.length;
        for (let i = 0; i < l; i++) {
          for (let j = i + 1; j < l; j++) {
            if (array[i] === array[j]) {
              i++;
              j = i;
            }
          }
          temp.push(array[i]);
          index.push(i);
        }
        return temp;
      },
      // 导出文件
      handleExport() {
        const tableColumn = this.$refs.siruiTable.getTableColumn();
        const showColumns = [];
        tableColumn.visibleColumn.forEach((item) => {
          if (item.property) {
            showColumns.push({ prop: item.property, label: item.title });
          }
        });
        showColumns.unshift({ prop: 'rowNo', label: '序号' });
        // if (tableColumn.length < 1) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t("salePurchase.noExportTips"),
        //     type: "error"
        //   });
        //   return;
        // }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        //如果当前页和历史页没有记录 ，则看搜索区域
        if (this.multipleSelection.length == 0 && selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: '请至少选择一条数据进行导出',
            type: 'error',
          });
          return;
        }
        const query = this.getQueryData();
        const params = filterEmpty(query);
        params.dataGroup = this.$globalVar.dataGroup;
        params.idsExport = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idsExport.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idsExport.push(item.id);
          });
        }
        // 导出字段
        params.columns = JSON.stringify(showColumns);
        //默认 制单日期倒叙
        params.orderByDesc = this.sortParams;

        this.loading.startLoading();
        // 获取数据
        this.$axios.post(API.EXPORT_ORDER_API, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type, '点击按钮');
        if (type == 'addOrder') {
          this.$refs.choiceType.openDialog(true, 'purchase_contract_detail_category');
        } else if (type == 'copy') {
          console.log('???');
          this.copyContract();
        } else if (type == 'delete') {
          this.delete();
        } else if (type == 'deleteApply') {
          this.deleteCommit();
        } else if (type == 'import') {
          this.importOrder();
        } else if (type == 'export') {
          this.handleExport();
        } else if (type == 'submit') {
          this.submitContract();
        } else if (type == 'addSupplierDelivery') {
          // 需选择一条已生效的且为采购合同或意向单的数据进行供应商发货
          let addSupplierDelivery = true;
          if (
            this.multipleSelection.length != 1 ||
            this.multipleSelection[0].contractStatus != 'ZT03'
          ) {
            addSupplierDelivery = false;
          } else {
            if (
              this.multipleSelection[0].contractDetailCategory == 'HT01' ||
              this.multipleSelection[0].contractDetailCategory == 'HT02' ||
              this.multipleSelection[0].contractDetailCategory == 'CG02'
            ) {
              addSupplierDelivery = false;
            }
          }
          if (!addSupplierDelivery) {
            this.$message({
              showClose: true,
              message: '请勾选一条已生效合同',
              type: 'error',
            });
            return;
          } else {
            let path = {
              path: '/wareHouse/addSupplierDelivery',
              name: 'addSupplierDelivery',
              meta: {
                keepAlive: true,
                title: '创建供应商发货指令',
              },
              query: {
                contractNo: this.multipleSelection[0].contractNo,
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        } else if (type == 'originalsReceivedBusiness') {
          //正本收集
          this.originalsReceived('originalsReceivedBusiness');
        } else if (type == 'originalsReceivedRm') {
          //正本归档
          this.originalsReceived('originalsReceivedRm');
        } else if (type == 'closeContract') {
          this.updateStatusHandler(0);
        } else if (type == 'printHandler') {
          if (this.multipleSelection.length) {
            // 调用接口打印
            console.log(this.multipleSelection, '数据');
            const contractNoList = this.multipleSelection.map((item) => item.contractNo);
            this.$axios.post(API.EXPORT_PRINT_API, { contractNos: contractNoList }).then((res) => {
              const {
                data: { code, data, msg },
              } = res;
              if (code == 0) {
                window.location.href = data.attachmentPath;
              } else {
                this.$message.error(msg);
              }
            });
          } else {
            this.$message.error('请选择行');
          }
        } else if (type == 'withdrawApprovalHandler') {
          if (!this.multipleSelection.length) {
            this.$message.error('请选择行');
            return;
          }
          // 判断只有审批中的才可以
          if (this.multipleSelection.some((item) => item.contractStatus != 'ZT02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return false;
          }
          let contractNos = [];
          let requestIds = [];
          this.multipleSelection.forEach((item) => {
            contractNos.push(item.contractNo);
            if (item.requestId) {
              requestIds.push(item.requestId);
            }
          });
          // const contractNos = this.multipleSelection.map((item) => item.contractNo);
          console.log(contractNos);
          this.loading.startLoading();
          this.$axios
            .post('/sales/order/batchAuditWithdrawOA', {
              contractNos: contractNos,
              requestIds: requestIds,
              contractCategory: 'purchase',
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              console.log(res);
              const { code, msg } = res.data;
              this.loading.endLoading();
              if (code == 0) {
                this.resetBtnClick();
                this.$message.success('撤回成功');
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              this.loading.endLoading();
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      // 关闭、激活、撤销
      updateStatusHandler(type) {
        const selectedList = this.$refs.siruiTable
          .getCheckboxRecords()
          .concat(this.$refs.siruiTable.getCheckboxReserveRecords()); // 当前页选中
        if (selectedList.length != 1) {
          this.$message({
            showClose: true,
            message: '只能选择一行操作',
            type: 'error',
          });
          return;
        }
        const rowData = selectedList[0];
        console.log(rowData.contractStatus, '====', rowData.id);
        if (rowData.contractStatus !== 'ZT03') {
          this.$message({
            showClose: true,
            message: '只能选择已生效合同/协议才能操作！',
            type: 'error',
          });
          return;
        }

        this.$confirm('确定要更改合同状态', '确认更改状态', {})
          .then(async () => {
            this.loading.startLoading();
            //0-关闭 1-激活 2-撤销
            let postData = {
              id: rowData.id,
              operateFlag: type,
              oaId: this.userInfo.userInfo.oaId,
            };
            const res = await this.$axios.post(ORDER_API.UPDATE_OTDER_STATUS, postData);
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      },
      //正本操作
      originalsReceived(type) {
        const selectedList = this.$refs.siruiTable
          .getCheckboxRecords()
          .concat(this.$refs.siruiTable.getCheckboxReserveRecords()); // 当前页选中
        if (selectedList.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        if (selectedList.find((item) => item.contractStatus !== 'ZT03')) {
          this.$message({
            showClose: true,
            message: '只有已生效合同才能操作！',
            type: 'error',
          });
          return;
        }
        this.$refs.OriginalsReceivedDialog.openDialog(true, type, {
          contractNo: selectedList.map((item) => item.contractNo),
        });
      },
      importOrder() {
        this.$refs.siruiUpload.openDialog(true, '110');
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiSearch.$refs.productRef &&
          this.$refs.siruiSearch.$refs.productRef[0] &&
          this.$refs.siruiSearch.$refs.productRef[0]?.resetClick();
        this.query.productNo = '';
        this.query.companyName = '';
        // this.query.customer = this.userInfo.userInfo.companyCode;
        this.getData();
      },
    },
  };
</script>
